import React from "react";
import Polar from "../Garments/Polar";

export default function PolarPage() {
  return <Polar />;
}
